// Removable chip for the active status filter
import { ApplicationStatus } from '@startus/applications';

interface FilterChipsProps {
  filter: ApplicationStatus | undefined;
  label: string;
  onClear: () => void;
}

export function FilterChips({ filter, label, onClear }: FilterChipsProps) {
  if (!filter) return null;

  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={onClear}
        className="badge badge-outline gap-1 cursor-pointer hover:badge-error transition-colors"
      >
        {label}
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
}
